// extracted by mini-css-extract-plugin
module.exports =  {"root":"KhtmR3hvmUDCXJ0EP2AX"};